export default __webpack_public_path__ + "static/media/logo.ee65dcbb.jpg";